import type { FC } from "react";
import { BRAND, SURFACE } from "@/theme/tokens";

export const GoogleIcon: FC<{ width?: number; height?: number }> = ({ width = 20, height = 21 }) => (
	<svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<title>Google Icon</title>
		<g clipPath="url(#clip0_4567_67417)">
			<path
				d="M19.2448 8.84101L11.087 8.84062C10.7268 8.84062 10.4348 9.13258 10.4348 9.49281V12.0989C10.4348 12.459 10.7268 12.7511 11.087 12.7511H15.6809C15.1779 14.0566 14.239 15.1499 13.0411 15.8446L15 19.2355C18.1422 17.4182 20 14.2296 20 10.6602C20 10.1519 19.9625 9.78859 19.8876 9.37949C19.8306 9.06867 19.5608 8.84101 19.2448 8.84101Z"
				fill={BRAND.GOOGLE.BLUE}
			/>
			<path
				d="M10 16.6667C7.75182 16.6667 5.78916 15.4383 4.73506 13.6206L1.3442 15.5751C3.06979 18.5658 6.30236 20.5797 10 20.5797C11.814 20.5797 13.5256 20.0913 15 19.2402V19.2355L13.0412 15.8445C12.1451 16.3642 11.1083 16.6667 10 16.6667Z"
				fill={BRAND.GOOGLE.GREEN}
			/>
			<path
				d="M15 19.2402V19.2355L13.0411 15.8445C12.1451 16.3641 11.1083 16.6666 10 16.6666V20.5797C11.8139 20.5797 13.5256 20.0913 15 19.2402Z"
				fill={BRAND.GOOGLE.GREEN_DARK}
			/>
			<path
				d="M3.91305 10.5797C3.91305 9.47155 4.21547 8.4348 4.73504 7.53882L1.34418 5.58437C0.488359 7.05417 0 8.76112 0 10.5797C0 12.3983 0.488359 14.1053 1.34418 15.5751L4.73504 13.6206C4.21547 12.7246 3.91305 11.6879 3.91305 10.5797Z"
				fill={BRAND.GOOGLE.YELLOW}
			/>
			<path
				d="M10 4.49276C11.4661 4.49276 12.8127 5.0137 13.8646 5.88022C14.124 6.09397 14.5012 6.07854 14.7389 5.84084L16.5854 3.99436C16.8551 3.72467 16.8358 3.28323 16.5478 3.03331C14.7854 1.50444 12.4925 0.579712 10 0.579712C6.30236 0.579712 3.06979 2.59366 1.3442 5.58436L4.73506 7.53881C5.78916 5.72112 7.75182 4.49276 10 4.49276Z"
				fill={BRAND.GOOGLE.RED}
			/>
			<path
				d="M13.8645 5.88022C14.124 6.09397 14.5012 6.07854 14.7389 5.84085L16.5854 3.99436C16.855 3.72467 16.8358 3.28323 16.5477 3.03331C14.7854 1.5044 12.4925 0.579712 10 0.579712V4.49276C11.466 4.49276 12.8127 5.0137 13.8645 5.88022Z"
				fill={BRAND.GOOGLE.RED_DARK}
			/>
		</g>
		<defs>
			<clipPath id="clip0_4567_67417">
				<rect width="20" height="20" fill={SURFACE} transform="translate(0 0.579712)" />
			</clipPath>
		</defs>
	</svg>
);
